import React from 'react';
import { IconSvgProps } from '@models/common';

const Ai: React.FC<IconSvgProps> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M5 17V21M3 19H7M14 3L16.2857 8.85714L22 11L16.2857 13.1429L14 19L11.7143 13.1429L6 11L11.7143 8.85714L14 3Z'
        stroke='currentColor'
        strokeWidth='1.8'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default Ai;
